import React, { useState,useEffect } from "react";
import { Link, useNavigate, useParams } from 'react-router-dom'
import axios from "axios"
import RichTextEditor from "@mantine/rte"
import { DatePicker, Space } from "antd"
import { api, exhibitionupdate, exhibitionview } from "../../apis/urls"
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from "yup"
import { Controller, useForm } from "react-hook-form"
import moment from "moment"
import { decode } from "html-entities";

const EditExhibition = () => {

    const [description, setDescription] = useState('')
    const [date, setDate] = useState('')
    const [loader, setLoader] = useState(true)
    const [image, setImage] = useState('')

    // get full year

    const getFullYear = () => {
        let year = new Date().getFullYear();
        let years = [];
        for (let i = 0; i < 10; i++) {
            years.push(year + i);
        }
        return years;
    }

    const validationSchema = yup.object().shape({
        name: yup.string().required('Exhibition Name is required'),
        year: yup.string().required('Year is required'),
        registration_date: yup.string().required('Registration Date is required'),
        agreement: yup.string().required('Agreement is required'),
    });

    const { id } = useParams();

    useEffect(()  => {
       editexhibitionAPI()
    },[]);
    

    let navigate = useNavigate()
    const RoutToList = () =>{
        navigate("/elecostlist")     
    }

    const editexhibitionAPI = () => {
        let token = "Bearer "+localStorage.getItem('token');
        const instance   = axios.create({
            baseURL: exhibitionview+id,
            timeout: 1000000,
            headers: {'authorization': token}
        });
        instance.get('').then((response) =>{
            setLoader(false)
            setValue('name', decode(response?.data?.data?.name))
            setValue('description',response?.data?.data?.description)
            setValue('year',response?.data?.data?.year)
            setValue('registration_date',response?.data?.data?.registration_date)
            setValue('agreement',response?.data?.data?.agreement)
            setDescription(response?.data?.data?.description)
            setDate(response?.data?.data?.registration_date)
            setPdf(response?.data?.data?.agreement)

            setImage(response?.data?.data?.image)

            if(response?.data?.data?.image){
                setFileSelect((response?.data?.data?.image).split("/")[3])
            }

        }).catch((error) =>{
            console.log('error',error.message)
        });
    }


    const onEditForm = (data) => {

            let token = "Bearer "+localStorage.getItem('token');
            
            const instance = axios.create({

                baseURL: exhibitionupdate+id,

                timeout: 1000000,

                headers: {'authorization': token}

            });
            
            instance.put('',data).then((response) =>{
                
                
                navigate("/exhibition")
            
            }).catch((error) =>{
                
                console.log('error',error.message)

            });
        
    }

    const { handleSubmit, register, formState:{errors}, setValue, control, getValues } = useForm({
        resolver: yupResolver(validationSchema)
    });

    const onSubmit = (data) => {
        const dataValue = {
            name :data.name,
            description :data.description,
            year:data.year,
            image:image,
            electricity: data.electricity,
            registration_date:data.registration_date,
            agreement:data.agreement
        }

        onEditForm(dataValue);
    }

    const [fileSelect, setFileSelect] = useState('');


    const  changeHandler=(event)=>{

        setFileSelect(event.name)

        let token = "Bearer "+localStorage.getItem('token');

        const data = new FormData();

        data.append('file', event)

        const instance = axios.create({
            baseURL: api+ 'workshopImage/upload',
            timeout: 1000000,
            headers: {'authorization': token, "Content-Type":  "multipart/form-data"},
        });

        instance.post('', data).then((response) =>{
            setImage(response.data.Location)
        }).catch((error) =>{     
            console.log('error',error.message)  
        });

    }

    const [pdf, setPdf] = useState('');

    const changeHandlerAgreement =(event)=>{

        let token = "Bearer "+localStorage.getItem('token');

        const data = new FormData();

        data.append('file', event)

        const instance = axios.create({
            baseURL: api+ 'workshopImage/upload',
            timeout: 1000000,
            headers: {'authorization': token, "Content-Type":  "multipart/form-data"},
        });

        instance.post('', data).then((response) =>{
            setValue('agreement', response?.data?.Location)
            setPdf(response?.data?.Location)
        }).catch((error) =>{     
            console.log('error',error.message)  
        });

    }

    return(
        <div className="wrapper">
            <aside className="right-side ">
                <div className="content-area">
                    <div className="page-title-wrpr">
                        <div className="page-title-left-column">
                            
                            <h2 className="page-title">Edit Exhibition</h2>
                        </div>
                        <div className="page-rightside-action-column">
                            
                            
                        </div>
                    
                    
                    </div>


                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                            <li className="breadcrumb-item"><Link to="/exhibition">Exhibitor</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Edit Exhibition</li>
                        </ol>
                    </nav>


                    {
                        !loader &&
                        <form onSubmit={handleSubmit(onSubmit)} className="needs-validation" noValidate>
                            <div className="form-wrpr">
                                <div className="card formcard medium">
                                    <div className="card-body">
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <label className="degreehead">Exhibition Name <span style={{color: "red"}}>*</span></label>
                                                    <input name="name" {...register('name')} type="text" className="form-control bg-dark dark-theme showtext" id="name"></input>
                                                    <p className="error-text message">{errors?.name?.message}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <label className="degreehead">Description</label>
                                                    { description &&  
                                                        <Controller
                                                            name="description"
                                                            control={control}
                                                            defaultValue={`${description}`}
                                                            render={({ field }) => <RichTextEditor {...field} />}
                                                        />
                                                    }
                                                </div>
                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label style={{fontSize:'12.8px', fontWeight: 400}} className="degreehead">Year<span style={{color: "red"}}>*</span></label>
                                                    <select {...register('year')} name="year" className="form-control bg-dark dark-theme showtext" id="status-selector" >
                                                        <option value="">Select Year</option>
                                                        {getFullYear().map
                                                            (year => (
                                                                <option key={year} value={year}>
                                                                    {year}
                                                                </option>
                                                            ))
                                                        }
                                                    </select>
                                                    <p className="error-text message">{errors?.year?.message}</p>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-exhibition-group date-exhibition">
                                                        <label className="degreehead">Registration Deadline<span style={{color: "red", fontSize:'12.8px', fontWeight: 400}}>*</span></label>
                                                        {
                                                            date &&
                                                            <Controller
                                                                name="registration_date"
                                                                control={control}
                                                                render={({ field: { onChange } }) => (
                                                                    <DatePicker
                                                                        onChange={(date) => {
                                                                            const d = new Date(date).toLocaleDateString('fr-FR');
                                                                            console.log(date ? moment(date).format('YYYY-MM-DD'):'')   
                                                                            onChange(date && moment(date).format('YYYY-MM-DD'));
                                                                        }}
                                                                        defaultValue={moment(date, 'YYYY-MM-DD')}
                                                                        className="form-control showtext"
                                                                    />
                                                                )}
                                                            />
                                                        }
                                                        <p className="error-text message">{errors?.registration_date?.message}</p>
                                                    </div>
                                                </div>
                                            </div>
                                    </div>

                                        
                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-12">	
                                                    <label className="degreehead">Agreement<span style={{color: "red"}}>*</span></label>	
                                                    <div>
                                                        <div class='file-input' style={{background:"#e6e8eaab", width:'100%'}}>
                                                            <input type='file' onChange={(event)=>{changeHandlerAgreement(event.target.files[0]);}}  />	
                                                            <span span class='button' style={{background:'dodgerblue', color:'#fff', fontWeight:'500', fontSize:'12px'}}>Choose</span>
                                                            <span class='labels' style={{color:pdf?'dodgerblue':'gray', fontWeight:'500', fontSize:'12px', paddingLeft:pdf?'10px':null }} data-js-label>{!pdf?"No file selected":pdf}</span>
                                                        </div>
                                                        <p className="error-text message">{errors?.agreement?.message}</p>
                                                    </div>
                                                </div>
                                            </div>
							            </div>



                                        <div className="form-group">
                                            <div className="row">
                                                <div className="col-md-12">	
                                                    <label >You may upload a representative image of the exhibition</label>	
                                                    <div>
                                                        <div class='file-input file-conferecne' style={{background:"#e6e8eaab", width:'100%'}}>
                                                        <input type='file' onChange={(event)=>{changeHandler(event.target.files[0]);}} />	
                                                            {image?
                                                                <img src={image} width="5%" />:
                                                                <span span class='button' style={{background:'dodgerblue', color:'#fff', fontWeight:'500', fontSize:'12px'}}>Choose</span>
                                                            }
                                                        <span class='labels' style={{color:image?'dodgerblue':'gray', fontWeight:'500', fontSize:'12px', paddingLeft:image?'10px':null }} data-js-label>{!image?"No file selected":fileSelect}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        
                                        <h6 style={{color: "red"}}>* Required Fields</h6>
                                        <div className="form-group text-right">
                                            {/* <button className="btn btn-primary btn-gisa cancelbtn" onClick={RoutToList}>Cancel</button> */}
                                            <button type="submit" className="btn btn-primary btn-gisa">Update</button>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </form>
                    }



                    {
                        loader &&
                        <div className="loader" style={{textAlign:'center', marginTop:'20%'}}>
                            <div className="spinner-border text-primary" role="status">
                                <span className="sr-only">Loading...</span>
                            </div>
                        </div>
                    }




                </div>
            </aside>
        </div>

    )
}

export default EditExhibition;
